// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sfQv","placeholdersHeader":"styles_placeholdersHeader__mNxTY","editorStyle":"styles_editorStyle__144up","placeholdersBox":"styles_placeholdersBox__3zPVm"};